/**
 * Transform binary file into a base 64 string.
 */
export const transformFileToBase64 = (content) => {
    let binary = ''
    const bytes = new Uint8Array(content)
    const len = bytes.byteLength
    for (let i = 0; i < len; i++) {
        binary += String.fromCharCode(bytes[i])
    }
    const base64 = btoa(binary)
    return base64
}

export const transformBitsToMegabytes = (bits) => {
    if (bits) {
        return (bits * 0.000001).toFixed(1)
    }
    return 0
}

export const openInNewTab = (url) => {
    const win = window.open(url, '_blank')
    win.focus()
}